import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Spinner } from "@/components/common";
import AppShell from "@/components/layout/AppShell";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import BillEntry from "@/pages/BillEntry";
import Bills from "@/pages/Bills";
import Clients from "@/pages/Clients";
import Users from "@/pages/Users";
import Masters from "@/pages/Masters";
import Reviews from "@/pages/Reviews";
import Reports from "@/pages/Reports";
import AuditLogs from "@/pages/AuditLogs";
import SettingsPage from "@/pages/Settings";
import Profile from "@/pages/Profile";
import SalesEntry from "@/pages/SalesEntry";
import SalesHistory from "@/pages/SalesHistory";
import VatConsolidation from "@/pages/VatConsolidation";
import Portal from "@/pages/Portal";

const Protected = ({ roles, children }) => {
  const { user } = useAuth();
  if (user === null) return <Spinner />;
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/" replace />;
  return children;
};

const A = ["super_admin"];
const AS = ["super_admin", "staff"];

function AppRoutes() {
  const { user } = useAuth();
  return (
    <Routes>
      <Route path="/portal/:code" element={<Portal />} />
      <Route path="/login" element={user ? <Navigate to="/" replace /> : <Login />} />
      <Route element={<Protected><AppShell /></Protected>}>
        <Route index element={<Dashboard />} />
        <Route path="bills" element={<Bills />} />
        <Route path="bills/new" element={<Protected roles={AS}><BillEntry /></Protected>} />
        <Route path="bills/:id/edit" element={<Protected roles={AS}><BillEntry /></Protected>} />
        <Route path="sales/new" element={<Protected roles={AS}><SalesEntry /></Protected>} />
        <Route path="sales" element={<SalesHistory />} />
        <Route path="vat-consolidation" element={<VatConsolidation />} />
        <Route path="clients" element={<Clients />} />
        <Route path="staff" element={<Protected roles={A}><Users role="staff" /></Protected>} />
        <Route path="auditors" element={<Protected roles={A}><Users role="auditor" /></Protected>} />
        <Route path="vendors" element={<Protected roles={AS}><Masters kind="vendors" /></Protected>} />
        <Route path="items" element={<Protected roles={AS}><Masters kind="items" /></Protected>} />
        <Route path="reviews" element={<Reviews />} />
        <Route path="reports" element={<Reports />} />
        <Route path="audit-logs" element={<Protected roles={A}><AuditLogs /></Protected>} />
        <Route path="settings" element={<Protected roles={A}><SettingsPage /></Protected>} />
        <Route path="profile" element={<Profile />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
      <Toaster position="top-right" richColors closeButton />
    </AuthProvider>
  );
}
